// src/App.js
import React, { useState } from 'react';
import ProjectIntro from './ProjectIntro';
import RoomForm     from './RoomForm';

function App() {
  const [projectInfo, setProjectInfo] = useState({
    assessor: '',
    projectName: '',
    projectType: '',
    dateTime: new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }),
    propertyPhoto: null
  });

  const [rooms, setRooms] = useState([{
    id: 1,
    room: '',
    area: '',
    observations: '',
    pictures: [],
    labResults: [],
    iaqReadings: null,
    recommendations: '',
    requirements: { requirement:'', approxFt:'' },
    floor: '',
    compassDirection: ''
  }]);
  const [nextRoomId, setNextRoomId] = useState(2);

  // Load JSON
  const loadJson = e => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const { projectInfo: pi, rooms: rs } = JSON.parse(reader.result);
        setProjectInfo(pi);
        setRooms(rs);
        setNextRoomId(Math.max(...rs.map(r=>r.id)) + 1);
      } catch {
        alert('Invalid JSON');
      }
    };
    reader.readAsText(file);
  };

  // Save JSON at bottom
  const saveToJson = () => {
    const { projectName, projectType, assessor } = projectInfo;
    // mm-dd
    const now = new Date(projectInfo.dateTime);
    const mm  = String(now.getMonth()+1).padStart(2,'0');
    const dd  = String(now.getDate()).padStart(2,'0');
    const initials = assessor
      .split(' ')
      .map(n=>n[0].toUpperCase())
      .join('');
    const filename = `${projectName}_${projectType}_${mm}-${dd}_${initials}.json`;
    const payload = { projectInfo, rooms };
    const blob    = new Blob([JSON.stringify(payload, null,2)], { type:'application/json' });
    const url     = URL.createObjectURL(blob);
    const a       = document.createElement('a');
    a.href        = url;
    a.download    = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  // Handlers...
  const updateProjectInfo = (f,v) => setProjectInfo(pi=>({ ...pi,[f]:v }));
  const addRoom  = () => {
    setRooms(rs=>[...rs,{ id:nextRoomId, room:'', area:'', observations:'', pictures:[],
      labResults:[], iaqReadings:null, recommendations:'',
      requirements:{requirement:'',approxFt:''},
      floor:'', compassDirection:'' }]);
    setNextRoomId(n=>n+1);
  };
  const deleteRoom = id=>{
    if(rooms.length<=1){ alert('Cannot delete last room'); return; }
    if(window.confirm(`Delete Room ${id}?`)){
      setRooms(rs=>rs.filter(r=>r.id!==id));
    }
  };
  const updateRoomData = (id,data) =>
    setRooms(rs=>rs.map(r=>r.id===id?{...r,...data}:r));

  return (
    <div className="p-6">
      {/* Load at top */}
      <div className="mb-6">
        <input type="file" accept=".json" onChange={loadJson}/>
      </div>

      <ProjectIntro data={projectInfo} onChange={updateProjectInfo}/>

      {rooms.map(r=>(
        <RoomForm
          key={r.id}
          roomData={r}
          onDataChange={updateRoomData}
          onDeleteRoom={deleteRoom}
        />
      ))}

      <div className="mt-6 flex gap-4">
        <button
          className="bg-green-600 text-white px-4 py-2 rounded"
          onClick={addRoom}
        >
          Add Major Room
        </button>
      </div>

      {/* Save at bottom */}
      <div className="mt-8">
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded"
          onClick={saveToJson}
        >
          Save to JSON
        </button>
      </div>
    </div>
  );
}

export default App;